import withEditableWidget from '@/components/DashboardPageV2/Desktop/Widgets/Shared/HOC/withEditableWidget'
import { WidgetDefinition } from '@/components/DashboardPageV2/Desktop/Widgets/Shared/utils/WidgetRegistry'
import {
  MeasurementEdit,
  MeasurementView
} from '@/components/DashboardPageV2/Desktop/Widgets/Shared/Measurement'
import { environmentTypes } from '@/components/DashboardPageV2/Desktop/Widgets/Environment/types'
import {
  LIVE_QUERY,
  VALUE_CHART
} from '@/components/DashboardPageV2/Desktop/Widgets/Shared/Dynamic/config'
import { defaultQueryOptions } from '../Shared/Dynamic/config/defaults'

const EnvironmentWidget = withEditableWidget(MeasurementView, MeasurementEdit)

export class EnvironmentWidgetDefinition extends WidgetDefinition {
  constructor({
    widgetId,
    title,
    icon,
    measurement,
    queryOptionsList = null,
    component = null,
    defaultPosition = null,
    options = null,
    config = null,
    permissionIds = null,
    denyVisibility = null
  }) {
    const defaultPositionDefault = {
      md: [0, 0, 2, 3, 2, 2]
    }
    const configDefault = {
      query: LIVE_QUERY,
      chart: VALUE_CHART,
      range: null,
      interval: null
    }
    const measurementOrError =
      options?.measurement ||
      measurement ||
      EnvironmentWidgetDefinition.paramRequired('measurement')

    const optionsDefault = {
      fixedFactor: 1,
      scaleFactor: 1,
      measurement: measurementOrError,
      queryOptionsList: queryOptionsList || defaultQueryOptions
    }

    const superParams = {
      widgetId,
      title,
      icon,
      component: component ?? EnvironmentWidget,
      defaultPosition: defaultPosition ?? defaultPositionDefault,
      config: config ?? configDefault,
      options: options ?? optionsDefault,
      permissionIds: permissionIds,
      visibility: denyVisibility
    }

    if (!superParams.options.queryOptionsList) {
      superParams.options.queryOptionsList = defaultQueryOptions
    }

    super(superParams)
  }

  static paramRequired(param) {
    throw new Error(`EnvironmentWidgetDefinition: ${param} is required.`)
  }
}

export const EnvironmentWidgetDefinitions = () => {
  const types = environmentTypes()
  const environmentWidgets = Object.keys(types).map(key => {
    return new EnvironmentWidgetDefinition({ ...types[key] })
  })

  return environmentWidgets
}
